// This should follow the error code standard: https://gb-core-docs-dev.apps.cac.preview.pcf.manulife.com/docs/standards/errorhandling#error-codes
const ERROR_CODES = {
  /**
   * @apiError {E_FHUIBFF_ES_0001} VALIDATE_TRANSFER_TOKEN_FAILED Transfer token validation failed.
   */
  VALIDATE_TRANSFER_TOKEN_FAILED: 'E_FHUIBFF_ES_0001',

  /**
   * @apiError {E_FHUI_G_0001} STEP_UP_INITIATION_FAILED Error during initiation of step up.
   */
  STEP_UP_INITIATION_FAILED: 'E_FHUI_G_0001',

  /**
   * @apiError {E_BFF_ES_0001} GET_PARTIAL_JWT_FAILED Error occurred with calling /identity/v3/member/token
   */
  GET_PARTIAL_JWT_FAILED: 'E_BFF_ES_0001',

  /**
   * @apiError {E_BFF_ES_0002} GET_FULL_JWT_FAILED Error occurred with calling /identity/v3/member/token
   */
  GET_FULL_JWT_FAILED: 'E_BFF_ES_0002',

  /**
   * @apiError {E_BFF_ES_0003} GET_TRANSFER_TOKEN_FAILED Error occurred with fetching for new transfer token after successful step up
   */
  GET_TRANSFER_TOKEN_FAILED: 'E_BFF_ES_0003',
};

export default ERROR_CODES;
